import { ResourceVendor } from '../../__generated__/graphql';

const PASS_LEVEL_LOCKS = new Map([
  [ResourceVendor.DormakabaAmbiance, true],
  [ResourceVendor.DormakabaAtlas, true],
  [ResourceVendor.DormakabaSystem_6000, true],
]);

export default PASS_LEVEL_LOCKS;
